module.exports = __webpack_public_path__ + "static/media/Camera05.ab8c0bed.jpg";